// Sticky basket bar

document.addEventListener("DOMContentLoaded", () => {
  // Check if the necessary elements exist on the page
  const stickyBar = document.getElementById("sticky-basket-bar");
  const productTitleElement = document.querySelector(".prodinfo__title");
  const productPriceElement = document.querySelector(".prodinfo__price");
  const quantitySelectElement = document.getElementById("quantselect");
  const addToCartButton = document.querySelector("form[action='/cart/add'] .btn[type='submit']");
  
  // Only proceed if all required elements are found
  if (stickyBar && productTitleElement && productPriceElement && quantitySelectElement && addToCartButton) {
    
    // Get the product details
    const productTitle = productTitleElement.innerText;
    const productPrice = productPriceElement.innerText;
    const productQuantity = quantitySelectElement.value;
    
    // Populate the sticky bar with product details
    const stickyProductTitle = document.getElementById("sticky-product-title");
    const stickyProductPrice = document.getElementById("sticky-product-price");
    const stickyQuantitySelect = document.getElementById("sticky-product-quantity");

    stickyProductTitle.innerText = productTitle;
    stickyProductPrice.innerText = productPrice;
    
    // Populate quantity select
    stickyQuantitySelect.innerHTML = quantitySelectElement.innerHTML;
    stickyQuantitySelect.value = productQuantity;

    // Synchronize the quantity inputs
    quantitySelectElement.addEventListener("change", () => {
      stickyQuantitySelect.value = quantitySelectElement.value;
    });

    stickyQuantitySelect.addEventListener("change", () => {
      quantitySelectElement.value = stickyQuantitySelect.value;
    });

    // Throttled scroll listener to toggle sticky bar visibility
    const productInfoOffset = productTitleElement.offsetTop;
    let scrollTimeout;
    
    window.addEventListener("scroll", () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        if (window.scrollY > productInfoOffset) {
          stickyBar.classList.add("visible");
        } else {
          stickyBar.classList.remove("visible");
        }
      }, 100); // 100ms throttle to prevent too many scroll event triggers
    });

    // Add to cart functionality for sticky bar button
    const stickyAddToCart = document.getElementById("sticky-add-to-cart");
    if (stickyAddToCart) {
      stickyAddToCart.addEventListener("click", () => {
        addToCartButton.click();
      });
    }

  }
});

let swiper;

function initializeSwiper() {
  swiper = new Swiper('.swiper-container', {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
    },
  });
}

function destroySwiper() {
  if (swiper) {
    swiper.destroy(true, true);
  }
}

function moveImagesToCarousel() {
  const imageGrid = document.getElementById('image-grid');
  const imageCarousel = document.getElementById('image-carousel');
  const swiperWrapper = imageCarousel.querySelector('.swiper-wrapper');

  const newSlides = [];

  while (imageGrid.firstChild) {
    const img = imageGrid.firstChild;
    if (img.tagName === 'IMG' || img.tagName === 'A' || img.tagName === 'DIV') {
      const swiperSlide = document.createElement('div');
      swiperSlide.classList.add('swiper-slide');
      swiperSlide.appendChild(img);
      newSlides.push(swiperSlide);
    } else {
      imageGrid.removeChild(img);
    }
  }

  // Prepend in reverse order to maintain correct visual order
  newSlides.reverse().forEach(slide => {
    swiperWrapper.insertBefore(slide, swiperWrapper.firstChild);
  });

  imageGrid.style.display = 'none';
  imageCarousel.style.display = 'block';
  destroySwiper();
  initializeSwiper();
}

function moveImagesToGrid() {
  const imageGrid = document.getElementById('image-grid');
  const imageCarousel = document.getElementById('image-carousel');
  const swiperWrapper = imageCarousel.querySelector('.swiper-wrapper');
  const slides = swiperWrapper.querySelectorAll('.swiper-slide');

  slides.forEach((slide, index) => {
    const img = slide.firstChild;
    if (img) {
      if (index < 4) {
        imageGrid.appendChild(img);
      } else {
        swiperWrapper.appendChild(slide);
      }
    }
    swiperWrapper.removeChild(slide);
  });
  imageGrid.style.display = 'grid';
  imageCarousel.style.display = 'block';
  destroySwiper();
  initializeSwiper();
}

function adjustProductImages() {
  if (window.innerWidth <= 768) {
    moveImagesToCarousel();
  } else {
    moveImagesToGrid();
  }
}

window.addEventListener('resize', adjustProductImages);
window.addEventListener('load', function() {
  if (window.innerWidth <= 768) {
    moveImagesToCarousel();
  } else {
    initializeSwiper();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.getElementById('klaviyo-star-rating-widget-top');
  const target = document.getElementById('bundle-reviews'); // The reviews section

  if (trigger && target) {
    trigger.style.cursor = 'pointer';
    trigger.addEventListener('click', function () {
      const rect = target.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const targetTop = rect.top + scrollTop;

      const offset = targetTop - (window.innerHeight / 2);

      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    });
  }
});